export const ROLES = ['admin', 'manager', 'member'] as const;
export type Role = (typeof ROLES)[number];

export type Permission =
  | 'time:own'
  | 'reports:own'
  | 'reports:all'
  /** Edit, delete, reassign and add time entries of other people (admins and managers). */
  | 'time:others'
  | 'catalog:manage'
  | 'timeoff:request'
  | 'timeoff:approve'
  | 'users:manage'
  | 'rates:manage'
  | 'settings:manage'
  | 'holidays:manage'
  | 'import:run';

const MEMBER: Permission[] = ['time:own', 'reports:own', 'timeoff:request'];
const MANAGER: Permission[] = [...MEMBER, 'reports:all', 'time:others', 'catalog:manage', 'timeoff:approve'];
const ADMIN: Permission[] = [
  ...MANAGER,
  'users:manage',
  'rates:manage',
  'settings:manage',
  'holidays:manage',
  'import:run',
];

const GRANTS: Record<Role, ReadonlySet<Permission>> = {
  admin: new Set(ADMIN),
  manager: new Set(MANAGER),
  member: new Set(MEMBER),
};

export function can(role: Role, permission: Permission): boolean {
  return GRANTS[role]?.has(permission) ?? false;
}
